// portal-social-links.component.ts
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { SharedPortalViewService } from '../shared-portal-view.service';
import { WebsiteSocialLink } from '../../portal.model';
import { isWebsiteLoaded, selectWebsiteIdentity } from 'src/app/shared/store/_features/website/website.selector';
import { InOutAnimation } from 'src/app/shared/animations/animations';
import { websiteActions } from 'src/app/shared/store/_features/website/website.actions';
import { SharedOwnerDashboardService } from 'src/app/shared/layout/owner-dashboard/shared-owner-dashboard.service';
import { Title } from '@angular/platform-browser';
import { SocialLinkCreateComponent } from './social-link-create/social-link-create.component';

@Component({
  selector: 'app-portal-social-links',
  templateUrl: './portal-social-links.component.html',
  styleUrls: ['./portal-social-links.component.css'],
  animations: [InOutAnimation],
})
export class PortalSocialLinksComponent implements OnInit, OnDestroy {
  isWebsiteLoaded$ = this.store.select(isWebsiteLoaded);
  processing = false;
  socialLinks: WebsiteSocialLink[] = [];

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private cdr: ChangeDetectorRef,
    public sharedPortalViewService: SharedPortalViewService,
    private sharedOwnerDashboardService: SharedOwnerDashboardService,
    private title: Title,
  ) {}

  async ngOnInit(): Promise<void> {
    this.sharedOwnerDashboardService.setTitle(
      {
        main: 'Social Links',
        // Rewrite Sub Text
        sub: 'Add your social links to your website.',
      },
      [SocialLinkCreateComponent]
    );
    // this.sharedOwnerDashboardService.setBreadcrumbs({customBreadCrumbs: [{label: 'Products'}]})
    this.sharedOwnerDashboardService.setBreadcrumbs({ base: 'social-links' });

    this.title.setTitle('Social Links');
    this.store.dispatch(websiteActions.load());
    this.initializeStore();
   
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get linkCount(): number {
    return this.socialLinks.length;
  }

  get linkCountLabel(): string {
    return this.linkCount === 1 ? 'Link' : 'Links';
  }


  

  private initializeStore(): void {
    this.store
      .select(selectWebsiteIdentity)
      .pipe(takeUntil(this.destroy$))
      .subscribe((identity) => {
        this.socialLinks = identity.social_links
          ? [...identity.social_links]
          : [];
      });
  }


}